import React from "react";
import SvgFrag from "./../../images/frag-axe.svg"
import ImageFrag1 from "./../../images/A4xF1_ilofl_evenement_jp.jpg"
import ImageFrag2 from "./../../images/A4xF2ilofl_chantier_jp.jpg"
import ImageFrag3 from "./../../images/A4xF3 Montage.jpg"
import ImageFrag4 from "./../../images/A4xF4Ilot Fleurie avril 2001.jpg"
import ImageFrag5 from "./../../images/fragment-manquant.svg"

const openModal = (ev) => {
    console.log('test');
    var target = ev.target;
    if (target.classList.contains('frag--container')){
    } else if (target.parentNode.classList.contains('frag--container')){
        target = target.parentNode;
    } else if (target.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode;
    } else if (target.parentNode.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode.parentNode;
    }
    target.classList.toggle('show');
}

export default () => (
  <div className="frag--wrapper">
      <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F1</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag1} alt=""/>
                <span>Événement à l&#39;Ilôt Fleurie. Photographe inconnu, Archives de l&#39;Ilôt Fleurie, ca1993.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F2</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag2} alt=""/>
                <span>Les jardins de l&#39;Ilôt en chantier. Photographe inconnu, Archives de l&#39;Ilôt Fleurie, ca1998.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F3</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag3} alt=""/>
                <span>&quot;Système lymbique du prédateur&quot; de Bill Vasan (2003) et &quot;La grosse Bertha&quot; de Don Darby(2006). Photographes inconnus, Archives de l&#39;Ilôt Fleurie, ca2000.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F4</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag4} alt=""/>
                <span>La dernière nuit du Sommet des Amériques. Photogramme de Maïté Mardomingo, Tiré du film Zones Grises, 2002.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F5</span>
        <div className="frag--modal missing">
            <div className="frag--content">
                <ImageFrag5/>
                <span>Lieu touristique nouveau genre, l&#39;Ilôt attire des investissements privés. Photographe inconnu, année en cours.</span>
            </div>
        </div>
     </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/frag-axe4.js